import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type DataTableFiltersEvents = 'FILTERS_CHANGED';

export const dataTableFilters: Record<DataTableFiltersEvents, MixpanelEvent> = {
  FILTERS_CHANGED: {
    eventDescription: 'Data Filters were set',
    eventKey: 'data-table-filters-changed',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.DATA_TABLE
  }
} as const;
